import styled from 'styled-components'
import {Link as LinkS} from 'react-scroll'
import {FaTimes} from 'react-icons/fa'

export const SidebarContainer = styled.div`
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background: #fff;
    padding-top: 30px;
    z-index: 999;
    transition: 0.4s ease-in-out;
    top: ${({isOpen}) => (isOpen ? '0' : '-120%')};
`;

export const SideClose = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 0 10px;
    margin-bottom: 30px;
`;

export const SideIcon = styled(FaTimes)`
    color: #2b3180;
    font-size: 3rem;
    margin-right: 20px;
    cursor: pointer;
`;

export const SideLogo = styled.div`

    color: #2b3180;
    justify-self: flex-start;
    cursor: pointer;
    font-size: 2rem;
    display: flex;
    align-items: center;
    margin-left: 24px;
    font-weight: bold;
    text-decoration: none;
`;

export const SideList = styled.div`

    height: 80%;
    display: flex;
    flex-wrap: wrap;
    margin-top: 50px;
    overflow-y: auto;
`;

export const SideItem = styled(LinkS)`
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 2rem;
    width: 100%;
    height: 100px;
    color: #2b3180;;
    cursor: pointer;
    &:hover {
        color: #fff;
        background-color: #2b3180;
    }
`;